import { useMutation } from "@apollo/client";
import React, { useEffect, useRef } from "react";
import { CommunityFeedType } from "../../types";
import { DELETE_COMMUNITY_FEED } from "../../apollo/operations";
import { PiDotsThreeBold } from "react-icons/pi";
import { showToast } from "../../utils/showToast";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setChatWith } from "../../redux/slices/communityFeedSlice";

type DiscussOptionProps = {
  communityFeed: CommunityFeedType | undefined;
  refetch?: () => void;
  setEditContent: React.Dispatch<React.SetStateAction<boolean>>;
  toggle: boolean | (() => void);
};
const DiscussOption: React.FC<DiscussOptionProps> = ({
  communityFeed,
  setEditContent,
  refetch,
  toggle,
}) => {
  const [openOption, setOpenOption] = React.useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [deleteOption, setDeleteOption] = React.useState(false);
  // const [comFeeds, setComFeeds] = React.useState<CommunityFeedType[] | null>(
  //   null
  // );

  const [deletecommunityFeed, { loading: loadFeeds }] = useMutation(
    DELETE_COMMUNITY_FEED,
    {
      onCompleted(data) {
        // refetch(data);
        if (refetch) {
          refetch();
        }
        setDeleteOption(false);
        setOpenOption(false);
      },
    }
  );

  //The delete function for the post
  const handleDelete = () => {
    if (communityFeed?.id) {
      setDeleteOption(!deleteOption);
      deletecommunityFeed({
        variables: {
          where: {
            id: communityFeed?.id,
          },
        },
      }).then(() => {
        setDeleteOption(!deleteOption);
        showToast("Post deleted successful", "success");
      });
    }
  };
  const userID = window.localStorage.getItem("user");

  //This is to allow the option div to close if an option is clicked
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpenOption(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (loadFeeds) {
    document.body.classList.add("overflow-y-hidden");
  } else {
    document.body.classList.remove("overflow-y-hidden");
  }

  const handleEdit = () => {
    setOpenOption(false);
    setEditContent(true);
    if (typeof toggle === "function") {
      toggle();
    }
  };

  const handleOpenDelete = () => {
    setOpenOption(!openOption);
    setDeleteOption(!deleteOption);
  };
  
  let profilePics: string | null = "";

  if (
    communityFeed?.creator &&
    communityFeed.creator.ecobookProfile &&
    communityFeed.creator.ecobookProfile.profileImage !== null
  ) {
    const profileImage = communityFeed.creator?.ecobookProfile?.profileImage;

    if (profileImage !== null && profileImage !== undefined) {
      profilePics = profileImage;
    }
  }

  const dispatch = useDispatch();
  let chatID: any;
  if (userID && communityFeed?.creator.id) {
    if (userID.localeCompare(communityFeed?.creator.id) < 0) {
      chatID = `${userID}${communityFeed?.creator.id}`;
    } else if (userID.localeCompare(communityFeed?.creator.id) > 0) {
      chatID = `${communityFeed?.creator.id}${userID}`;
    }
  }

  const chatDetails = {
    id: chatID,
    profileImage: profilePics || null,
    name: `${communityFeed?.creator.firstName} ${communityFeed?.creator.lastName}`,
  };


  return (
    <div ref={containerRef}>
      {!loadFeeds ? (
        <div
          className="hover:bg-comPagBg relative active:bg-bgGrey rounded-full p-3 w-full"
          ref={containerRef}
        >
          <PiDotsThreeBold
            size={20}
            className="cursor-pointer transition active:ease-in-out"
            onClick={() => setOpenOption(!openOption)}
          />
        </div>
      ) : (
        loadFeeds && (
          <div
            className="hover:bg-comPagBg relative active:bg-bgGrey rounded-full p-3 w-full"
            ref={containerRef}
          >
            <PiDotsThreeBold
              size={20}
            />
          </div>
        )
      )}
      {openOption && (
        <ul className="bg-white w-[24%] z-10 py-4 px-2 text-center rounded-sm rounded-tr-none shadow-[1px_-1px_10px_5px_rgba(0,0,0,0.1)] transform translate-y-1 ease-linear font-Jakarta lg:text-xs text-[9px] font-semibold text-lightBlack duration-200 absolute right-8 top-9">
          <div className="absolute border-l-[20px] border-l-transparent border-b-white border-b-[25px] border-solid top-[-18px] right-0">
            {" "}
          </div>
          {userID === communityFeed?.creator.id && (
            <>
              <li
                className="w-[95%] text-center cursor-pointer hover:bg-gray-100 py-1 hover:rounded"
                onClick={handleOpenDelete}
              >
                Delete post
              </li>
              <li
                className="w-[95%] cursor-pointer hover:bg-gray-100 py-1 hover:rounded my-1"
                onClick={handleEdit}
              >
                Edit
              </li>
            </>
          )}
          {userID !== communityFeed?.creator.id && (
            <li className="w-[95%] cursor-pointer hover:bg-gray-100 py-1 hover:rounded">
              <Link to={`/chat/e/${chatID}`}>
                <p onClick={() =>  dispatch(setChatWith(chatDetails))}>Message user</p>
              </Link>
            </li>
          )}
          {/*<li className="w-[95%] cursor-pointer hover:bg-gray-100 py-1 hover:rounded my-1">
            Share to
          </li>
          <li className="w-[95%] cursor-pointer hover:bg-gray-100 py-1 hover:rounded">
            Copy link
          </li>
          <li className="w-[95%] cursor-pointer hover:bg-gray-100 py-1 hover:rounded my-1">
            About this account
          </li> */}
          <li
            className="w-[95%] cursor-pointer hover:bg-gray-100 py-1 hover:rounded"
            onClick={() => setOpenOption(!openOption)}
          >
            Cancel
          </li>
        </ul>
      )}

      {deleteOption && (
        <div className="fixed inset-0 z-30 align-middle flex justify-center items-center transition-colors overflow-y-hidden bg-black/20">
          <div className="bg-[#FFF] w-[30%] h-[225px] shadow rounded p-8 font-Rubik flex flex-col gap-5">
            <h1 className=" text-darkGreen text-base font-medium">
              Delete post
            </h1>
            <p className=" text-xs text-[#67727E]">
              Are you sure you want to delete this Post? This will remove the
              post and can’t be undone.
            </p>
            <div className="flex justify-between font-Rubik font-medium text-white">
              <div
                className="px-8 rounded py-3 shadow bg-[#67727E] text-base text-center cursor-pointer hover:text-darkGreen active:ml-1 active:mt-px transition duration-75"
                onClick={() => setDeleteOption(!deleteOption)}
              >
                NO, CANCEL
              </div>
              <div
                className="px-8 py-3 rounded shadow bg-midGreen text-center cursor-pointer hover:text-lightGreen active:bg-white active:ease-linear transition duration-75"
                onClick={handleDelete}
              >
                YES, DELETE
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DiscussOption;
